import { render, staticRenderFns } from "./CustomerDepartments.vue?vue&type=template&id=fdbc188c"
import script from "./CustomerDepartments.vue?vue&type=script&lang=js"
export * from "./CustomerDepartments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports